import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@tvg/design-system";
import mediator from "@tvg/mediator";
import {
  closeMybetsPastPerformance,
  closeMyBetsStandalone
} from "@tvg/sh-lib-my-bets/redux/actions";
import { useNavigate } from "@tvg/custom-hooks";
import { getIsLogged } from "@urp/store-selectors";
import MyBetsModalHeader from "./header";
import { Props } from "./types";
import MyBetsTopStickyArea from "./topStickyArea";

const MyBetsModal = ({
  currentPath,
  isPastPerformanceOpen,
  isVideoShown,
  title,
  selectedTab,
  selectedSettledTab,
  qaLabel,
  isOpen,
  children,
  onScroll
}: Props) => {
  const dispatch = useDispatch();
  const isLogged = useSelector(getIsLogged);
  const history = useNavigate();
  const Header = <MyBetsModalHeader title={title} />;
  const TopStickyArea = (
    <MyBetsTopStickyArea
      isPastPerformanceOpen={isPastPerformanceOpen}
      showBannerFeedback={!isVideoShown}
    />
  );

  const closeMyBetsModal = () => {
    history.push(currentPath);
    dispatch(closeMyBetsStandalone());
    mediator.base.dispatch({
      type: "MYBETS_CLICKS_X_BUTTON",
      payload: {
        selectedTab,
        selectedSettledTab
      }
    });
  };

  useEffect(() => {
    if (isOpen && !isLogged) {
      closeMyBetsModal();
    }
  }, [isLogged]);

  return (
    <Modal
      isOpen={isOpen}
      onBack={
        isPastPerformanceOpen
          ? () => {
              dispatch(closeMybetsPastPerformance());
            }
          : undefined
      }
      title={Header}
      headerLeftElement={<></>}
      qaLabel={qaLabel}
      onAfterClose={closeMyBetsModal}
      type="modal-custom-height"
      topStickyArea={TopStickyArea}
      hasBorderBottom={false}
      p={0}
      maxHeight={isVideoShown ? "68%" : undefined}
      onScroll={onScroll}
    >
      {children}
    </Modal>
  );
};

export default MyBetsModal;
